import React, { useState, useRef, useCallback } from 'react';
import { isEmpty } from 'ramda';

import SendIcon from '../../icons/SendIcon';
import ButtonSendChatMessage from '../ButtonWrapper/components/ButtonSendChatMessage';

import '../../assets/components/AiNotePopup.css';

const MOODS = ['Dreamy', 'Warm', 'Energetic', 'Cold', 'Dark'];

const AiNotePopup = ({ mode, icon, color, selection, onSend, onReset, onClose }) => {
    const [note, setNote] = useState('');
    const [selectedMood, setSelectedMood] = useState(null);
    const textareaRef = useRef(null);

    const canSend = note && !isEmpty(note) && (mode === 'penai' || !!selection);

    const handleTextareaChange = useCallback((e) => {
        setNote(e.target.value);
    }, []);

    const handleKeyDown = useCallback((e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            if (canSend) {
                onSend(note, selection, selectedMood);
            }
        }
    }, [note, selection, selectedMood, onSend, canSend]);

    const handleSend = useCallback(() => {
        if (canSend) {
            onSend(note, selection, selectedMood);
        }
    }, [note, selection, selectedMood, onSend, canSend]);

    const handleReset = useCallback(() => {
        if (onReset) onReset();
    }, [onReset]);

    return (
        <div className="aiNotePopup" style={{ '--ai-note-color': color }}>
            <div className="aiNotePopup__header">
                <span className="aiNotePopup__icon">{icon}</span>
                <span className="aiNotePopup__label">Add your note</span>
                {selection && (
                    <span className="aiNotePopup__selectionBadge">
                        {selection.layer} selected
                    </span>
                )}
                {mode === 'penai' && onReset && (
                    <button
                        type="button"
                        className="aiNotePopup__resetBtn"
                        onClick={handleReset}
                    >
                        Reset
                    </button>
                )}
            </div>
            {mode === 'moodai' && (
                <div className="aiNotePopup__moods">
                    {MOODS.map(mood => (
                        <button
                            key={mood}
                            type="button"
                            className={`aiNotePopup__moodBadge${selectedMood === mood ? ' aiNotePopup__moodBadge--active' : ''}`}
                            onClick={() => setSelectedMood(prev => prev === mood ? null : mood)}
                        >
                            {mood}
                        </button>
                    ))}
                </div>
            )}
            <div className="aiNotePopup__body">
                <textarea
                    ref={textareaRef}
                    className="aiNotePopup__textarea"
                    value={note}
                    maxLength={2000}
                    placeholder="Describe your note..."
                    onChange={handleTextareaChange}
                    onKeyDown={handleKeyDown}
                    autoFocus
                />
            </div>
            <div className="aiNotePopup__actions">
                {!selection && mode !== 'penai' && (
                    <p className="aiNotePopup__hint">Select a region on the timeline</p>
                )}
                <ButtonSendChatMessage
                    disabled={!canSend}
                    onClick={handleSend}
                >
                    <SendIcon />
                </ButtonSendChatMessage>
            </div>
        </div>
    );
};

export default AiNotePopup;
